import { $host } from './index';
import { ENDPOINTS } from '../constants/endpoints';

export const getCart = () => async (dispatch) => {
  try {
    dispatch({ type: 'App/SET_ACTIVITY', payload: true });
    const { data } = await $host.get(ENDPOINTS.CART.INFO);
    const { data: productsResponse } = await $host.get(ENDPOINTS.PRODUCTS.LIST, {
      params: { limit: 100 }
    });
    const products = productsResponse.data;

    dispatch({
      type: 'Cart/SET',
      payload: data.map((item) => ({
        id: item.id,
        productId: item.denomination?.product?.t_product_id,
        name: products.find((p) => p.t_product_id === item.denomination?.product?.t_product_id)?.name,
        name_lv: products.find((p) => p.t_product_id === item.denomination?.product?.t_product_id)?.name_lv,
        imgUrl: products.find((p) => p.t_product_id === item.denomination?.product?.t_product_id)?.imgUrl,
        quantity: item.quantity,
        denominationId: item.denomination.id,
        denominationName: item.denomination.name,
        denominationName_lv: item.denomination.name_lv,
        price: item.denomination.price,
        stock: item.denomination.stock
      }))
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  } finally {
    dispatch({ type: 'App/SET_ACTIVITY', payload: false });
  }
};

export const getCartSummary = async (paymentType) => {
  try {
    const { data } = await $host.get(ENDPOINTS.CART.SUMMARY, { params: { paymentType } });
    return data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  }
};

export const addToCart = (product, denomination, quantity) => async (dispatch, getState) => {
  try {
    dispatch({ type: 'App/SET_ACTIVITY', payload: true });

    const state = getState();
    if (state.user.id) {
      await $host.post(ENDPOINTS.CART.ADD, {
        denominationId: denomination.id,
        quantity: quantity
      });
    }
    dispatch({
      type: 'Cart/ADD',
      payload: {
        ...product,
        id: denomination.id,
        quantity,
        productId: product.id,
        denominationName: denomination.name,
        denominationName_lv: denomination.name_lv,
        denominationId: denomination.id,
        price: denomination.price,
        stock: denomination.stock
      }
    });
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  } finally {
    dispatch({ type: 'App/SET_ACTIVITY', payload: false });
  }
};

export const deleteFromCart = (productId, denominationId) => async (dispatch, getState) => {
  try {
    const state = getState();
    if (state.user.id) {
      await $host.delete(ENDPOINTS.CART.DELETE, {
        params: { denominationId }
      });
    }
    dispatch({ type: 'Cart/REMOVE', payload: productId });
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  }
};

export const updateInCart =
  (productId, denominationId, quantity) => async (dispatch, getState) => {
    try {
      const state = getState();
      if (state.user.id) {
        await $host.patch(
          ENDPOINTS.CART.UPDATE,
          { quantity },
          { params: { denominationId } }
        );
      }
      dispatch({ type: 'Cart/SET_QUANTITY', payload: { id: productId, quantity } });
    } catch (error) {
      console.log(error);
      throw error?.response?.data;
    }
  };
